import React from "react";
import { Address, DocumentUrl, SectionModel } from "../../models/guarantorCheque.model";
import DetailInfoComponentThumbnail from "../../components/thumbnail/detailInfoComponentThumbnail";
import DivisionCmp from "../../components/cards/DivisionCmp";
import SellerIdentityInfo from "./sellerIdentityInfo";
import GuarantorIdentityInfo from "./guarantorIdentityInfo";
import DevisionGuarantorCmp from "../../components/cards/devisionGuarantorCmp";


interface SchemaInfoModel {
    data?: Address;
    documentList: DocumentUrl[];
    withoutDoc: boolean;
}
function _GuarantorDocument({ data, documentList, withoutDoc }: SchemaInfoModel) {
    const sections: SectionModel[] = [
        { dataKey: "fullName", rowCol: 3, title: " نام و نام خانوادگی" },
        { dataKey: "nationalCode", rowCol: 3, title: " کدملی" },
        { dataKey: "mobileNumber", rowCol: 3, title: " شماره موبایل" },
        { dataKey: "shenasnamehNumber", rowCol: 3, title: "شماره شناسنامه" },
        { dataKey: "fatherName", rowCol: 3, title: "نام پدر" },
        { dataKey: "birthdate_Persian", rowCol: 3, title: "تاریخ تولد" },
        // { dataKey: "postalCode", rowCol: 3, title: "کدپستی" },
    ];
    return (
        <DetailInfoComponentThumbnail
            sections={sections}
            data={data}
            documentList={[]}
            height={"20vh"}
            addressByInquiry={true}
            showFooter={false}
            showDoc={withoutDoc}
            isGuarantor={true}
        />
    );
}

export default function GuarantorDocument(props: any) {
    let documentUrlList = [] as DocumentUrl[];
    documentUrlList = props.data?.data?.documentUrls;
    const child = (
        <>
            <_GuarantorDocument
                data={props.data.data}
                documentList={documentUrlList}
                withoutDoc={props.withoutDoc}
            />
        </>
    );

    return (
        <>
            <DevisionGuarantorCmp child={child} title={props.title ? props.title : "مدارک هویتی فروشنده"} />
            <GuarantorIdentityInfo data={props?.data?.data?.identityDocuments!} />
        </>
    );
}
